<template>
  <dx-popup
    :visible.sync="isVisible"
    :drag-enabled="false"
    :close-on-outside-click="true"
    :show-title="true"
    :title="$t('select')"
  >
    <dx-scroll-view>
      <div class="d-flex mb-4">
        <dx-text-box
          v-model="search"
          class="ml-auto"
          value-change-event="input"
          styling-mode="outlined"
          :max-length="1000"
          :placeholder="$t('search')"
          @input="debounceGetItems"
        />
      </div>
      <div class="list">
        <dx-list
          :items="items"
          :selected-items.sync="selectedItems"
          item-delete-mode="toggle"
          selection-mode="single"
          allow-item-deleting
          class="wrap"
        />
      </div>
      <b-row class="mx-1 mt-4">
        <dx-button
          :text="$t('select')"
          :disabled="!selectedItems.length"
          type="success"
          styling-mode="contained"
          class="custom-btn mr-2 ml-auto"
          @click="submit"
        />
        <dx-button
          :text="$t('Cancel')"
          type="success"
          styling-mode="text"
          class="custom-btn"
          @click="isVisible = false"
        />
      </b-row>
    </dx-scroll-view>
  </dx-popup>
</template>

<script>
import { mapState } from 'vuex';

import { DxButton, DxTextBox } from 'devextreme-vue';
import { DxPopup } from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue/scroll-view';

import DxList from 'devextreme-vue/list';
import debounce from 'lodash.debounce';

export default {
  name: 'AutocompleteModal',
  components: {
    DxList,
    DxButton,
    DxPopup,
    DxScrollView,
    DxTextBox,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    field: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    search: '',
    items: [],
    selectedItems: [],
    debounce,
  }),
  computed: {
    ...mapState(['user']),
    isVisible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
    debounceGetItems() {
      return debounce(this.getItems, 400);
    },
  },
  created() {
    this.getItems();
  },
  methods: {
    async getItems() {
      const params = {};
      if (this.search) {
        params.search = this.search;
      }
      const { results } = await this.$http.get(`tracking/api/directory/freight-order-suggestion?field_name=${this.field}`, { params });
      this.items = results;
    },
    submit() {
      this.isVisible = false;
      this.$emit('selected', this.selectedItems[0]);
    },
  },
};
</script>

<style lang="scss">
.wrap .dx-list-item-content {
  white-space: normal;
}
</style>
